<template>
    <div class="adminArea">
        <label class="titlelabel">Filter Attributes</label>
        <p class="subtext">Choose which product-attribute groups appear as filters on your storefront
            (the filter sidebar on the shop page). Changes take effect after the short storefront cache refresh.</p>
        <div><label class="responsemessage">{{message}}</label></div>

        <div style="overflow-x:auto;">
        <table class="attrTable" v-if="attributeTypes.length">
            <thead>
                <tr>
                    <th>Attribute</th>
                    <th>Values</th>
                    <th>Show as storefront filter</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <template v-for="t in attributeTypes" :key="t.productCategoryTypeID">
                    <tr>
                        <td class="attrName">{{t.name}}</td>
                        <td>{{t.valueCount}}</td>
                        <td class="centercell">
                            <input type="checkbox" class="entryCheckbox"
                                   :checked="t.includeAsFilter"
                                   @change="toggleFilter(t, $event.target.checked)">
                        </td>
                        <td>
                            <smallbutton :toplabel="expanded[t.productCategoryTypeID] ? 'Hide values' : 'View values'"
                                         buttonclass="button buttonsave imgcardbtn" @click="toggleValues(t)"/>
                        </td>
                    </tr>
                    <tr v-if="expanded[t.productCategoryTypeID]">
                        <td colspan="4" class="valuesCell">
                            <span v-for="v in (valuesByType[t.productCategoryTypeID] || [])" :key="v.productCategoryID"
                                  class="valueChip" :class="{inactiveChip: !v.isActive}">{{v.name}}</span>
                            <span v-if="!(valuesByType[t.productCategoryTypeID] || []).length" class="subtext">No values.</span>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
        <p v-else class="subtext">{{listMessage}}</p>
        </div>
    </div>
</template>

<script>
import datamethods from '../../services/datamethods.js'
import smallbutton from '../controls/button.vue'
export default {
    name: 'filterattributes',
    components: { smallbutton },
    mixins: [datamethods],
    data() {
        return {
            attributeTypes: [],
            valuesByType: {},
            expanded: {},
            message: '',
            listMessage: 'Loading filter attributes…'
        }
    },
    async created() {
        await this.getFilterAttributes()
    },
    methods: {
        async getFilterAttributes() {
            this.message = ''
            var response = await this.callAPI(null, 'ecommerce/admin/filterattributes')
            if (response.Successful) {
                this.attributeTypes = response.filterAttributes || []
                if (!this.attributeTypes.length) { this.listMessage = 'No filter attributes found.' }
            } else {
                this.message = response.Message || 'Failed to load filter attributes'
                this.listMessage = this.message
            }
        },
        async toggleFilter(t, newVal) {
            var response = await this.callAPI(
                { productCategoryTypeID: t.productCategoryTypeID, includeAsFilter: newVal },
                'ecommerce/admin/filterattribute/setfilter')
            if (response.Successful) {
                t.includeAsFilter = newVal
                this.message = '"' + t.name + '" ' + (newVal ? 'is now shown as a storefront filter.' : 'is no longer a storefront filter.')
            } else {
                // leave t.includeAsFilter unchanged so the checkbox rebinds to its prior state
                this.message = response.Message || 'Update failed'
            }
        },
        async toggleValues(t) {
            // Vue 3: this.$set does not exist; assign reactively via object spread.
            var id = t.productCategoryTypeID
            this.expanded = { ...this.expanded, [id]: !this.expanded[id] }
            if (this.expanded[id] && !this.valuesByType[id]) {
                var response = await this.callAPI({ productCategoryTypeID: id }, 'ecommerce/admin/filterattribute/values')
                if (response.Successful) { this.valuesByType = { ...this.valuesByType, [id]: response.values || [] } }
                else { this.message = response.Message || 'Failed to load values' }
            }
        }
    }
}
</script>

<style scoped>
.adminArea { padding: 12px; }
.subtext { color: #777; font-size: 13px; max-width: 640px; }
.attrTable { border-collapse: collapse; margin-top: 12px; min-width: 560px; }
.attrTable th, .attrTable td { border-bottom: 1px solid #eee; padding: 8px 16px; text-align: left; }
.attrTable th { font-size: 13px; color: #555; }
.attrName { font-weight: 600; }
.centercell { text-align: center; }
.valuesCell { background: #fafafa; }
.valueChip { display: inline-block; background: #eef; border: 1px solid #dde; border-radius: 12px; padding: 2px 10px; margin: 3px; font-size: 13px; }
.inactiveChip { opacity: .5; text-decoration: line-through; }
.imgcardbtn { padding: 2px 10px; }
</style>
